<template>
    <form class="acc-glass w-full rounded-2xl border border-white/10 p-5" @submit.prevent="save">
        <div class="text-lg font-extrabold tracking-tight">Налаштування · Сповіщення</div>
        <div class="mt-4 space-y-3">
            <label class="flex items-start justify-between gap-4 rounded-xl border border-white/10 bg-white/5 px-3 py-3">
                <span class="min-w-0">
                    <span class="block text-sm font-semibold text-white/90">Email-сповіщення</span>
                    <span class="mt-1 block text-sm leading-relaxed text-white/60">
                        Отримувати на email сповіщення про відповіді та згадки, досягнення й нові нагороди.
                    </span>
                </span>
                <input v-model="form.email_notifications" type="checkbox" class="mt-1 shrink-0" />
            </label>
            <p class="text-xs leading-relaxed text-white/50">Обов’язкові листи акаунта та безпеки надсилаються завжди.</p>
            <button type="submit" class="acc-btn-primary w-full justify-center" :disabled="saving">
                {{ saving ? 'Збереження...' : 'Зберегти налаштування' }}
            </button>
            <div v-if="message" class="text-xs text-emerald-300" role="status" aria-live="polite">{{ message }}</div>
            <div v-if="error" class="text-xs text-red-300" role="alert" aria-live="assertive">{{ error }}</div>
        </div>
    </form>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script lang="js">
import axios from 'axios';

export default {
    props: {
        profile: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            form: {
                email_notifications: true,
            },
            saving: false,
            message: '',
            error: '',
        };
    },
    watch: {
        profile: {
            immediate: true,
            handler(value) {
                this.applySettings(value?.settings);
            },
        },
    },
    methods: {
        applySettings(settings) {
            if (!settings) return;
            this.form.email_notifications = settings.email_notifications !== false;
        },
        async save() {
            if (this.saving) return;
            this.saving = true;
            this.message = '';
            this.error = '';
            try {
                const { data } = await axios.put('/api/account/profile/notifications', {
                    email_notifications: this.form.email_notifications,
                });
                this.applySettings(data?.settings);
                this.message = data?.message || 'Налаштування сповіщень збережено.';
            } catch (e) {
                this.error = e?.response?.data?.message || 'Не вдалося зберегти налаштування сповіщень.';
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
